module.exports = __webpack_public_path__ + "static/media/i22.2253d286.jpg";